import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { Box, Chip, Typography } from "@mui/material";
var PhysicalPhenamenaDataGrid = function (props) {
    var _value$ParamsBeforeRe, _value$ParamsAfterRep;
    var value = props.value, _a = props.name, name = _a === void 0 ? "PhysicalPhenamena" : _a;
    var ParametersBeforeRepairColumns = [{
            field: "SrNo",
            headerName: "Parameter No",
            width: 100,
            editable: false,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            field: "CheckedParams",
            headerName: "Parameters Checked",
            flex: 1,
            editable: false
        }, {
            field: "Observations",
            headerName: "Observations",
            flex: 1,
            editable: false
        }];
    var ParametersAfterRepairColumns = [{
            field: "SrNo",
            headerName: "Parameter No",
            width: 100,
            editable: false,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            field: "CheckedParams",
            headerName: "Parameters Checked",
            flex: 1,
            editable: false
        }, {
            field: "Observations",
            headerName: "Observations",
            flex: 1,
            editable: false
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: ParametersBeforeRepairColumns,
        rows: (_value$ParamsBeforeRe = value === null || value === void 0 ? void 0 : value.ParamsBeforeRepairData) !== null && _value$ParamsBeforeRe !== void 0 ? _value$ParamsBeforeRe : [],
        disableAddRow: true,
        disableDeleteRow: true,
        disableToolbarActions: true,
        dataGridProps: {
            hideFooter: true,
            slots: {
                toolbar: function (params) {
                    return /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        p: 1,
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "subtitle2",
                        fontSize: 13,
                        fontWeight: "strong"
                    }, "Parameters Before Repair"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "".concat(params === null || params === void 0 ? void 0 : params.chipLabel, "/5"),
                        color: "primary",
                        variant: "outlined"
                    }));
                }
            },
            disableColumnMenu: true,
            checkboxSelection: false,
            sx: {
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.secondary',
                    width: '100%'
                },
                '& .MuiDataGrid-row': {
                    backgroundColor: 'background.secondary'
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: ParametersAfterRepairColumns,
        rows: (_value$ParamsAfterRep = value === null || value === void 0 ? void 0 : value.ParamsAfterRepairData) !== null && _value$ParamsAfterRep !== void 0 ? _value$ParamsAfterRep : [],
        disableAddRow: true,
        dataGridHeader: "Parameters while repair",
        disableDeleteRow: true,
        disableToolbarActions: true,
        dataGridProps: {
            slots: {
                toolbar: function (params) {
                    return /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        p: 1,
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "subtitle2",
                        fontSize: 13,
                        fontWeight: "strong"
                    }, "Parameters While Repair"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "".concat(params === null || params === void 0 ? void 0 : params.chipLabel, "/5"),
                        color: "primary",
                        variant: "outlined"
                    }));
                }
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            sx: {
                mt: 2,
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.secondary',
                    width: '100%'
                },
                '& .MuiDataGrid-row': {
                    backgroundColor: 'background.secondary'
                }
            }
        }
    }));
};
export default PhysicalPhenamenaDataGrid;
